<div class="inner-content p-30 flex flex-col items-center justify-center gap-7">
  <div class="container flex flex-col items-start justify-center gap-4">
    <h1>{{ appService.ordersBlockedTitle }}</h1>
    <p class="p1">
      {{ appService.ordersBlockedBody }}
    </p>
    <div class="w-100 flex flex-row gap-2">
      <ion-button class="flex-grow" color="dark" (click)="close()">De acuerdo</ion-button>
    </div>
  </div>
</div>
